const createClusterSvg = (pointCount: number) => {
  const size = pointCount < 10 ? 50 : pointCount < 100 ? 65 : 80
  const fontSize = pointCount < 10 ? 12 : pointCount < 100 ? 14 : 16

  const getColors = (count: number) => {
    if (count < 20) {
      return { outer: '#4285f4', inner: '#1a73e8', text: 'white' }
    } else {
      return { outer: '#ea4335', inner: '#d33b2c', text: 'white' }
    }
  }

  const { outer, inner, text } = getColors(pointCount)

  return `
        <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
          <rect 
            x="0" 
            y="0" 
            width="${size}" 
            height="${size}" 
            fill="transparent" 
            stroke="none"
          />
          
          <circle 
            cx="${size / 2}" 
            cy="${size / 2}" 
            r="${size / 2 - 2}" 
            fill="${outer}" 
            fill-opacity="0.7"
          />
          
          <circle 
            cx="${size / 2}" 
            cy="${size / 2}" 
            r="${size * 0.3}" 
            fill="${inner}" 
            fill-opacity="0.9"
          />
          
          <text 
            x="${size / 2}" 
            y="${size / 2 + fontSize / 3}" 
            text-anchor="middle" 
            fill="${text}" 
            font-family="Arial, sans-serif" 
            font-size="${fontSize}" 
            font-weight="bold"
          >
            ${pointCount}
          </text>
        </svg>
      `
}

const svgToDataURL = (svg: string) => {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}

const getHeatmapColorRange = () : [number, number, number, number][] => {
  return [
    [255, 255, 178, 150], //rgb(255, 255, 130)
    [254, 217, 118, 150], //rgb(255, 217, 118)
    [254, 178, 76, 150], // #feb24c
    [253, 141, 60, 150], // #fd8d3c
    [240, 59, 32, 150], // #f03b20
    [189, 0, 38, 150], // #bd0026
  ]
}

export { createClusterSvg, svgToDataURL, getHeatmapColorRange }
